import httpClient from '@/lib/httpClient.js'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useResendVerificationEmailNotification() {
  const action = async ({ email }) => {
    const response = await httpClient.post(
      '/auth/email/verification-notification',
      {
        email,
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
  })

  return {
    resend: mutation.mutateAsync,
    resendStatus: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
